import React,{useState} from 'react';
import {createPortal} from 'react-dom';
import {Copy} from 'lucide-react';
import {ContextMenu} from './ContextMenu';
import {useLang,copyToClipboard} from './i18n';

// Right-click on a role: copies its id for bot code.
export function useRoleIdMenu(){
 const [,,tr]=useLang();
 const [at,setAt]=useState<{x:number;y:number;id:string}|null>(null);
 const open=(e:React.MouseEvent,id:string)=>{e.preventDefault();e.stopPropagation();setAt({x:e.clientX,y:e.clientY,id});};
 // On the page itself: inside a dialog the menu would be cut off and in the wrong place.
 const menu=at&&createPortal(<div className="role-id-menu"><ContextMenu x={at.x} y={at.y} onClose={()=>setAt(null)} actions={[{label:tr('Copy Role ID','Rollen-ID kopieren'),icon:<Copy size={15}/>,run:()=>void copyToClipboard(at.id)}]}/></div>,document.body);
 return {open,menu};
}
